import axios from '../config/axios';

const API_BASE = '/vehicle-owners';

export const vehicleOwnerService = {
  // Get all vehicle owners
  getAllOwners: (page = null, perPage = null, filters = {}) => {
    const params = {
      ...(page && { page }),
      ...(perPage && { per_page: perPage }),
      ...filters
    };
    return axios.get(API_BASE, { params });
  },

  // Get single vehicle owner
  getOwner: (ownerId) => {
    return axios.get(`${API_BASE}/${ownerId}`);
  },

  // Create vehicle owner
  createOwner: (data) => {
    return axios.post(API_BASE, data);
  },

  // Update vehicle owner
  updateOwner: (ownerId, data) => {
    return axios.put(`${API_BASE}/${ownerId}`, data);
  },

  // Delete vehicle owner
  deleteOwner: (ownerId) => {
    return axios.delete(`${API_BASE}/${ownerId}`);
  }
};